export const SHAPES = ['네모', '세모', '마름모'];

export const MAIN_STAT_OPTIONS = [
  '상관없음',
  '공격력(%)', '공격력(수치)',
  '체력(%)', '체력(수치)',
  '방어력(%)', '방어력(수치)',
  '회복력(%)', '회복력(수치)',
  '치명확률(%)', '치명타 피해(%)',
  '효과저항(%)', '효과적중(%)',
];

export const SUB_STAT_OPTIONS = [
  '공격력(%)', '공격력(수치)',
  '체력(%)', '체력(수치)',
  '방어력(%)', '방어력(수치)',
  '회복력(%)', '회복력(수치)',
  '치명확률(%)', '치명타 피해(%)',
  '효과저항(%)', '효과적중(%)',
];

export const ALL_GEM_SETS = [
  '상관없음 (최고 스펙 조합)',
  '투지의 보석 (공격력 +20%)', '맹렬한 보석 (공격력 +150)',
  '생명의 보석 (체력 +20%)', '강인한 보석 (체력 +2500)',
  '수호의 보석 (방어력 +20%)', '견고한 보석 (방어력 +150)',
  '예리한 보석 (치명확률 +20%)', '파괴의 보석 (치명타 피해 +40%)',
  '신념의 보석 (효과저항 +20%)', '적중의 보석 (효과적중 +20%)',
  '활력의 보석 (회복력 +25%)', '자비의 보석 (회복력 +150)',
  '맹공의 보석 (공격력/치명확률 +15%)', '불굴의 보석 (방어력/효과저항 +10%)',
  '철갑의 보석 (치명타 피해 +30% / 방어력 +15%)', '구원의 보석 (체력/회복력 +15%)',
  '대담한 보석 (효과저항/체력 +10%)', '충격의 보석 (기절 확률 +20%)',
  '흡혈의 보석 (HP 흡수 +20%)', '흡수의 보석 (SP 흡수 +40%)',
  '치유의 보석 (HP 회복 +10%)', '명상의 보석 (SP 회복 +10%)',
  '면역의 보석 (면역 2턴 부여 / 면역 +100%)', '경감의 보석 (피해량 15% 감소)',
  '방벽의 보석 (피해량 흡수 보호막 생성 / 보호막 +15000)',
];

export const KNOWN_SET_KEYS = ALL_GEM_SETS
  .filter((x) => !x.startsWith('상관없음'))
  .map((x) => x.split('(')[0].trim().replace(/의 보석$/, ''));

export const PRIORITY_GOALS = [
  '🎯 커스텀우선 (설정한 필터/세트 조건 최우선)',
  '⚔️ 공공치 (공격력/공격력/치명타 피해)',
  '⚔️ 공공치확 (공격력/공격력/치명확률)',
  '🛡️ 체체체 (체력/체력/체력)',
  '🛡️ 체체방 (체력/체력/방어력)',
  '🛡️ 방방체 (방어력/방어력/체력)',
  '💚 회회방 (회복력/회복력/방어력)',
  '💚 회회체 (회복력/회복력/체력)',
  '💚 회체체 (회복력/체력/체력)',
  '💚 회체방 (회복력/체력/방어력)',
  '💚 회방방 (회복력/방어력/방어력)',
];

// Direct-stat set effects. Utility effects that are not part of the existing score
// (stun, lifesteal, shield, SP, immunity, damage reduction) are deliberately not
// converted into made-up stat points.
export const SET_BONUSES = {
  투지: { atk_pct: 20 },
  맹렬: { atk_flat: 150 },
  생명: { hp_pct: 20 },
  강인: { hp_flat: 2500 },
  수호: { def_pct: 20 },
  견고: { def_flat: 150 },
  예리: { crit_rate: 20 },
  파괴: { crit_dmg: 40 },
  신념: { res: 20 },
  적중: { acc: 20 },
  활력: { rec_pct: 25 },
  자비: { rec_flat: 150 },
  맹공: { atk_pct: 15, crit_rate: 15 },
  불굴: { def_pct: 10, res: 10 },
  철갑: { crit_dmg: 30, def_pct: 15 },
  구원: { hp_pct: 15, rec_pct: 15 },
  대담: { res: 10, hp_pct: 10 },
};

// Verified +15 main-stat maxima, used to compare gems at their finished value.
// Unknown/unsupported main-stat types keep their observed value.
const MAIN_STAT_MAX = {
  1: { hpFlat: 3300, otherFlat: 152, pct: 17, cdmg: 17, res: 17, crate: 17 },
  2: { hpFlat: 5100, otherFlat: 258, pct: 27, cdmg: 27, res: 27, crate: 24.2 },
  3: { hpFlat: 6900, otherFlat: 364, pct: 37, cdmg: 37, res: 37, crate: 30 },
  4: { hpFlat: 8700, otherFlat: 470, pct: 47, cdmg: 47, res: 47, crate: 37.2 },
  5: { hpFlat: 10500, otherFlat: 576, pct: 57, cdmg: 57, res: 55.2, crate: 45.8 },
  6: { hpFlat: 12400, otherFlat: 715, pct: 68, cdmg: 70, res: 61, crate: 54 },
};

export function normalizeShape(shape) {
  const s = String(shape ?? '').trim().toLowerCase();
  if (s.includes('네모') || s.includes('사각') || s.includes('■') || s === 'square') return '네모';
  if (s.includes('세모') || s.includes('삼각') || s.includes('▲') || s === 'triangle') return '세모';
  if (s.includes('마름모') || s.includes('◆') || s.includes('◇') || s.includes('♦') || s.includes('diamond') || s.includes('rhombus')) return '마름모';
  return String(shape ?? '').split('(')[0].trim();
}

export function normalizeStatName(name) {
  const s = String(name ?? '').replaceAll(' ', '').replace(/[()%]/g, '');
  if ((s.includes('치') && s.includes('확')) || s.includes('크리확률') || s.includes('크리티컬확률')) return '치명확률';
  if (s.includes('치명타피해') || s.includes('치명피해') || s.includes('치피')) return '치명타피해';
  if (s.includes('효과저항') || s.includes('효저')) return '효과저항';
  if (s.includes('효과적중') || s.includes('효적') || s === '적중') return '효과적중';
  if (s.includes('공')) return '공격력';
  if (s.includes('체')) return '체력';
  if (s.includes('방')) return '방어력';
  if (s.includes('회')) return '회복력';
  return String(name ?? '').trim();
}

export function parseNumeric(value) {
  const text = String(value ?? '').trim();
  const match = text.match(/[-+]?\d+(?:\.\d+)?/);
  return { value: match ? Number(match[0]) : 0, isPct: text.includes('%') };
}

export function formatStat(stat) {
  if (!stat) return '-';
  if (typeof stat !== 'object') return String(stat);
  const name = stat.name ?? '';
  const raw = String(stat.value ?? '').trim();
  const parsed = parseNumeric(raw);
  if (!raw || !Number.isFinite(parsed.value)) return `${name} ${raw}`.trim();
  return `${name} ${parsed.value.toFixed(1)}${parsed.isPct ? '%' : ''}`.trim();
}

export function getMainStat15Value(name, originalValue, isPct, gem) {
  const starRaw = gem?.stars ?? gem?.star ?? gem?.grade ?? 6;
  const star = Math.min(6, Math.max(1, Number.parseInt(starRaw, 10) || 6));
  const table = MAIN_STAT_MAX[star];
  const stat = normalizeStatName(name);
  if (!table) return originalValue;

  if (['체력', '공격력', '방어력', '회복력'].includes(stat)) {
    if (isPct) return table.pct;
    return stat === '체력' ? table.hpFlat : table.otherFlat;
  }
  if (stat === '치명타피해') return table.cdmg;
  if (stat === '치명확률') return table.crate;
  if (stat === '효과저항') return table.res;
  return originalValue;
}

export function applyMslShapeRules(gem) {
  const next = { ...gem };
  const stat = normalizeStatName(next.main_stat?.name);
  if (stat === '치명확률') next.shape = '네모';
  else if (stat === '치명타피해') next.shape = '세모';
  else if (stat === '효과저항') next.shape = '마름모';
  else next.shape = normalizeShape(next.shape || '네모');
  return next;
}

export function normalizeLoadedGems(input) {
  if (!Array.isArray(input)) throw new Error('parsed_gems.json 최상위 구조는 배열이어야 합니다.');
  return input.map((raw, index) => {
    const g = applyMslShapeRules({ ...(raw ?? {}) });
    return {
      ...g,
      id: Number.isFinite(Number(g.id)) ? Number(g.id) : index + 1,
      status: g.status || '정상',
      is_uncertain: Boolean(g.is_uncertain),
      equipped_to: g.equipped_to ?? null,
      equipped_monster_uid: g.equipped_monster_uid ?? null,
      equipped_variant_key: g.equipped_variant_key ?? null,
      equipped_element: g.equipped_element ?? null,
      equipped_evolution: g.equipped_evolution ?? null,
      equipped_stat_type: g.equipped_stat_type ?? null,
      equipped_monster_name_kor: g.equipped_monster_name_kor ?? null,
      equipped_instance_no: g.equipped_instance_no ?? null,
      main_stat: typeof g.main_stat === 'object' && g.main_stat ? g.main_stat : { name: '', value: '' },
      sub_stats: Array.isArray(g.sub_stats) ? g.sub_stats : [],
    };
  });
}

export function reindexGems(gems) {
  return gems.map((g, i) => ({ ...g, id: i + 1 }));
}

export function cleanEquippedLabel(label) {
  return String(label ?? '').replace(/<[^>]+>\s*/g, '').replace(/\s*\(\d+\)\s*$/, '').trim();
}

export function nextInstanceNo(gems, monsterName) {
  const base = cleanEquippedLabel(monsterName);
  let max = 0;
  for (const g of gems) {
    const label = g.equipped_to;
    if (!label || cleanEquippedLabel(label) !== base) continue;
    const m = String(label).match(/\((\d+)\)\s*$/);
    if (m) max = Math.max(max, Number(m[1]));
  }
  return max + 1;
}

export function checkMainStatMatch(mainStat, target) {
  if (!target || target === '상관없음') return true;
  const statName = normalizeStatName(mainStat?.name ?? mainStat);
  const targetName = normalizeStatName(target);
  if (statName !== targetName) return false;

  // The UI distinguishes percent and flat values. Keep that distinction for
  // HP/ATK/DEF/REC while percentage-only stats simply match by name.
  if (['체력', '공격력', '방어력', '회복력'].includes(targetName)) {
    const isPct = parseNumeric(mainStat?.value ?? '').isPct;
    if (String(target).includes('(%)')) return isPct;
    if (String(target).includes('(수치)')) return !isPct;
  }
  return true;
}

export function parseGemStats(gem, base = {}) {
  const baseHp = Number(base.hp || 0);
  const baseAtk = Number(base.atk || 0);
  const baseDef = Number(base.def || 0);
  const baseRec = Number(base.rec || 0);
  const pct = { hp: 0, atk: 0, def: 0, rec: 0, crate: 0, cdmg: 0, res: 0, acc: 0 };
  const flat = { hp: 0, atk: 0, def: 0, rec: 0 };
  const subDict = {};

  const add = (name, raw, isMain = false) => {
    const stat = normalizeStatName(name);
    const parsed = parseNumeric(raw);
    let val = parsed.value;
    if (isMain) val = getMainStat15Value(stat, val, parsed.isPct, gem);

    const put = (key, amount) => { subDict[key] = (subDict[key] || 0) + amount; };
    if (stat === '체력') {
      if (parsed.isPct) pct.hp += val; else flat.hp += val;
      if (!isMain) put(parsed.isPct ? '체력(%)' : '체력(수치)', val);
    } else if (stat === '공격력') {
      if (parsed.isPct) pct.atk += val; else flat.atk += val;
      if (!isMain) put(parsed.isPct ? '공격력(%)' : '공격력(수치)', val);
    } else if (stat === '방어력') {
      if (parsed.isPct) pct.def += val; else flat.def += val;
      if (!isMain) put(parsed.isPct ? '방어력(%)' : '방어력(수치)', val);
    } else if (stat === '회복력') {
      if (parsed.isPct) pct.rec += val; else flat.rec += val;
      if (!isMain) put(parsed.isPct ? '회복력(%)' : '회복력(수치)', val);
    } else if (stat === '치명확률') {
      pct.crate += val;
      if (!isMain) put('치명확률(%)', val);
    } else if (stat === '치명타피해') {
      pct.cdmg += val;
      if (!isMain) put('치명타 피해(%)', val);
    } else if (stat === '효과저항') {
      pct.res += val;
      if (!isMain) put('효과저항(%)', val);
    } else if (stat === '효과적중') {
      pct.acc += val;
      if (!isMain) put('효과적중(%)', val);
    }
  };

  if (gem?.main_stat?.name) add(gem.main_stat.name, gem.main_stat.value, true);
  for (const sub of gem?.sub_stats ?? []) {
    if (sub && typeof sub === 'object') add(sub.name, sub.value, false);
  }

  return {
    gem,
    shape: normalizeShape(gem?.shape || '네모'),
    sub_dict: subDict,
    pct,
    flat,
    hp: baseHp * pct.hp / 100 + flat.hp,
    atk: baseAtk * pct.atk / 100 + flat.atk,
    def: baseDef * pct.def / 100 + flat.def,
    rec: baseRec * pct.rec / 100 + flat.rec,
    crate: pct.crate,
    cdmg: pct.cdmg,
    res: pct.res,
    acc: pct.acc,
  };
}

export function extractSetKey(gem) {
  const full = `${gem?.set_option ?? ''} ${gem?.name ?? ''}`;
  return KNOWN_SET_KEYS.find((key) => full.includes(key)) ?? null;
}

function requestedMains(priorityGoal) {
  if (priorityGoal.includes('공공치확')) return ['공격력', '공격력', '치명확률'];
  if (priorityGoal.includes('공공치')) return ['공격력', '공격력', '치명타피해'];
  if (priorityGoal.includes('체체체')) return ['체력', '체력', '체력'];
  if (priorityGoal.includes('체체방')) return ['체력', '체력', '방어력'];
  if (priorityGoal.includes('방방체')) return ['방어력', '방어력', '체력'];
  if (priorityGoal.includes('회회방')) return ['회복력', '회복력', '방어력'];
  if (priorityGoal.includes('회회체')) return ['회복력', '회복력', '체력'];
  if (priorityGoal.includes('회체체')) return ['회복력', '체력', '체력'];
  if (priorityGoal.includes('회체방')) return ['회복력', '체력', '방어력'];
  if (priorityGoal.includes('회방방')) return ['회복력', '방어력', '방어력'];
  return null;
}

function createEmptyPct() {
  return { hp: 0, atk: 0, def: 0, rec: 0, crate: 0, cdmg: 0, res: 0, acc: 0 };
}

function createEmptyFlat() {
  return { hp: 0, atk: 0, def: 0, rec: 0 };
}

export function getSetBonusBreakdown(key) {
  const b = SET_BONUSES[key] || {};
  return {
    pct: {
      hp: b.hp_pct || 0,
      atk: b.atk_pct || 0,
      def: b.def_pct || 0,
      rec: b.rec_pct || 0,
      crate: b.crit_rate || 0,
      cdmg: b.crit_dmg || 0,
      res: b.res || 0,
      acc: b.acc || 0,
    },
    flat: {
      hp: b.hp_flat || 0,
      atk: b.atk_flat || 0,
      def: b.def_flat || 0,
      rec: b.rec_flat || 0,
    },
  };
}

function addBreakdown(targetPct, targetFlat, bonus) {
  for (const k of Object.keys(targetPct)) targetPct[k] += bonus.pct[k] || 0;
  for (const k of Object.keys(targetFlat)) targetFlat[k] += bonus.flat[k] || 0;
}

function comboScore(totals, priorityGoal) {
  const { hp, atk, def, rec, crate, cdmg, res } = totals;
  if (priorityGoal.includes('공공치확')) return atk + crate * 500 + cdmg * 30;
  if (priorityGoal.includes('공공치')) return atk + cdmg * 300 + crate * 50;
  if (['체체체', '체체방', '방방체'].some((k) => priorityGoal.includes(k))) return hp * 0.1 + def * 0.8 + res * 20 + crate * 10;
  if (priorityGoal.includes('회')) return rec + res * 30 + hp * 0.1 + def * 0.5;
  return atk + hp * 0.1 + def * 0.8 + crate * 30 + cdmg * 20;
}

function gemPotential(item, priorityGoal, subFilters) {
  const totals = {
    hp: item.hp, atk: item.atk, def: item.def, rec: item.rec,
    crate: item.crate, cdmg: item.cdmg, res: item.res, acc: item.acc,
  };
  let score = comboScore(totals, priorityGoal);
  for (const f of subFilters) score += (item.sub_dict?.[f.stat] || 0) * 100;
  return score;
}

function pruneSlot(items, priorityGoal, subFilters, limit = 120) {
  if (items.length <= limit) return items;
  const keep = new Map();
  const addTop = (arr, n) => arr.slice(0, n).forEach((x) => keep.set(x.gem.id, x));

  addTop([...items].sort((a, b) => gemPotential(b, priorityGoal, subFilters) - gemPotential(a, priorityGoal, subFilters)), Math.floor(limit * 0.55));

  for (const setKey of Object.keys(SET_BONUSES)) {
    const setItems = items.filter((x) => extractSetKey(x.gem) === setKey)
      .sort((a, b) => gemPotential(b, priorityGoal, subFilters) - gemPotential(a, priorityGoal, subFilters));
    addTop(setItems, 8);
  }

  for (const filter of subFilters) {
    const statItems = [...items].sort((a, b) => (b.sub_dict?.[filter.stat] || 0) - (a.sub_dict?.[filter.stat] || 0));
    addTop(statItems, 20);
  }

  const arr = [...keep.values()].sort((a, b) => gemPotential(b, priorityGoal, subFilters) - gemPotential(a, priorityGoal, subFilters));
  return arr.slice(0, Math.max(limit, 120));
}

export function calculateTop3GemCombos({
  normalGems,
  base,
  slotSettings,
  targetSet,
  priorityGoal,
  subFilters = [],
  includeAllEquipped = false,
  includeSameStarmonGems = false,
  currentMonName = '',
  exactCombinationLimit = 2_000_000,
}) {
  const reqMains = requestedMains(priorityGoal);
  const reqSetName = targetSet.includes('상관없음') ? null : targetSet.split('(')[0].trim();
  const cleanCurrent = cleanEquippedLabel(currentMonName);

  const candidates = [];
  for (const g of normalGems) {
    if (g.status === '보류' || g.status === '휴지통') continue;
    if (g.equipped_to) {
      if (includeAllEquipped) {
        // include
      } else if (includeSameStarmonGems && cleanCurrent && cleanEquippedLabel(g.equipped_to) === cleanCurrent) {
        // include
      } else continue;
    }
    if (reqSetName && !String(g.set_option || '').includes(reqSetName) && !String(g.name || '').includes(reqSetName)) continue;
    candidates.push(parseGemStats(g, base));
  }

  let slots = slotSettings.map((slot) => {
    const main = reqMains ? '상관없음' : (slot.main || '상관없음');
    return candidates.filter((item) => normalizeShape(item.shape) === normalizeShape(slot.shape)
      && (main === '상관없음' || checkMainStatMatch(item.gem.main_stat, main)));
  });

  if (slots.some((s) => s.length === 0)) {
    return { results: [], meta: { exact: true, slotCounts: slots.map((s) => s.length), searchedCombinations: 0, originalCombinations: 0 } };
  }

  const originalCounts = slots.map((s) => s.length);
  const originalCombinations = originalCounts.reduce((a, b) => a * b, 1);
  let exact = true;
  if (originalCombinations > exactCombinationLimit) {
    exact = false;
    slots = slots.map((s) => pruneSlot(s, priorityGoal, subFilters, 120));
  }

  const [list1, list2, list3] = slots;
  const bestResults = [];
  let searchedCombinations = 0;

  const compareResults = (a, b) => b.filterSortScore - a.filterSortScore || b.score - a.score;
  const keepIfTop3 = (candidate) => {
    const key = candidate.comboKey;
    const existing = bestResults.findIndex((x) => x.comboKey === key);
    if (existing >= 0) {
      if (compareResults(candidate, bestResults[existing]) < 0) bestResults[existing] = candidate;
    } else {
      bestResults.push(candidate);
    }
    bestResults.sort(compareResults);
    if (bestResults.length > 3) bestResults.length = 3;
  };

  for (const g1 of list1) {
    for (const g2 of list2) {
      if (g1.gem.id === g2.gem.id) continue;
      for (const g3 of list3) {
        searchedCombinations += 1;
        const ids = [g1.gem.id, g2.gem.id, g3.gem.id];
        if (new Set(ids).size !== 3) continue;
        const comboKey = [...ids].sort((a, b) => a - b).join(',');
        const combo = [g1, g2, g3];

        if (reqMains) {
          const mains = combo.map((x) => normalizeStatName(x.gem.main_stat?.name)).sort();
          const target = [...reqMains].sort();
          if (mains.some((x, i) => x !== target[i])) continue;
        }

        const subSums = {};
        for (const item of combo) {
          for (const [key, value] of Object.entries(item.sub_dict || {})) subSums[key] = (subSums[key] || 0) + value;
        }
        let filterSortScore = 0;
        let filtersOk = true;
        for (const f of subFilters) {
          const actual = subSums[f.stat] || 0;
          if (f.cond === '이상' && actual < Number(f.val)) { filtersOk = false; break; }
          if (f.cond === '이하' && actual > Number(f.val)) { filtersOk = false; break; }
          filterSortScore += actual;
        }
        if (!filtersOk) continue;

        // Keep gem stats and set-bonus stats separate first, then merge them.
        // This makes it impossible for the set effect to disappear silently from
        // the final values and also lets the UI show exactly what the 3-set added.
        const gemPct = createEmptyPct();
        const gemFlat = createEmptyFlat();
        for (const item of combo) {
          for (const k of Object.keys(gemPct)) gemPct[k] += item.pct[k] || 0;
          for (const k of Object.keys(gemFlat)) gemFlat[k] += item.flat[k] || 0;
        }

        const setKeys = combo.map((x) => extractSetKey(x.gem));
        const activeSet = setKeys[0] && setKeys.every((x) => x === setKeys[0]) ? setKeys[0] : null;
        const setBonus = activeSet ? getSetBonusBreakdown(activeSet) : { pct: createEmptyPct(), flat: createEmptyFlat() };

        const totPct = { ...gemPct };
        const totFlat = { ...gemFlat };
        addBreakdown(totPct, totFlat, setBonus);

        const totals = {
          hp: Number(base.hp || 0) * totPct.hp / 100 + totFlat.hp,
          atk: Number(base.atk || 0) * totPct.atk / 100 + totFlat.atk,
          def: Number(base.def || 0) * totPct.def / 100 + totFlat.def,
          rec: Number(base.rec || 0) * totPct.rec / 100 + totFlat.rec,
          crate: totPct.crate,
          cdmg: totPct.cdmg,
          res: totPct.res,
          acc: totPct.acc,
        };
        const score = comboScore(totals, priorityGoal);
        keepIfTop3({
          combo,
          comboKey,
          score,
          filterSortScore,
          ...totals,
          gem_pct: gemPct,
          gem_flat: gemFlat,
          set_bonus_pct: setBonus.pct,
          set_bonus_flat: setBonus.flat,
          tot_pct: totPct,
          tot_flat: totFlat,
          activeSet,
        });
      }
    }
  }

  return {
    results: bestResults.map(({ comboKey, ...result }) => result),
    meta: { exact, slotCounts: slots.map((s) => s.length), originalCounts, searchedCombinations, originalCombinations },
  };
}

export function summarizeEquippedStats(gems, monster) {
  const base = {
    hp: Number(monster?.hp || 30000),
    atk: Number(monster?.attack || 3000),
    def: Number(monster?.defence || 2500),
    rec: Number(monster?.recovery || 2000),
  };
  const gemPct = createEmptyPct();
  const gemFlat = createEmptyFlat();
  for (const gem of gems) {
    const p = parseGemStats(gem, base);
    for (const k of Object.keys(gemPct)) gemPct[k] += p.pct[k] || 0;
    for (const k of Object.keys(gemFlat)) gemFlat[k] += p.flat[k] || 0;
  }
  const setKeys = gems.map(extractSetKey);
  const activeSet = gems.length >= 3 && setKeys[0] && setKeys.every((x) => x === setKeys[0]) ? setKeys[0] : null;
  const setBonus = activeSet ? getSetBonusBreakdown(activeSet) : { pct: createEmptyPct(), flat: createEmptyFlat() };
  const totPct = { ...gemPct };
  const totFlat = { ...gemFlat };
  addBreakdown(totPct, totFlat, setBonus);

  const increase = {
    hp: base.hp * totPct.hp / 100 + totFlat.hp,
    atk: base.atk * totPct.atk / 100 + totFlat.atk,
    def: base.def * totPct.def / 100 + totFlat.def,
    rec: base.rec * totPct.rec / 100 + totFlat.rec,
  };
  const final = {
    hp: base.hp + increase.hp,
    atk: base.atk + increase.atk,
    def: base.def + increase.def,
    rec: base.rec + increase.rec,
    crate: Number(monster?.crit_rate ?? 10) + totPct.crate,
    cdmg: Number(monster?.crit_dmg ?? 150) + totPct.cdmg,
    res: Number(monster?.resist ?? 20) + totPct.res,
    acc: totPct.acc,
  };
  return {
    base,
    gemPct,
    gemFlat,
    setBonusPct: setBonus.pct,
    setBonusFlat: setBonus.flat,
    totPct,
    totFlat,
    increase,
    final,
    activeSet,
  };
}
